import { Injectable, inject } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { BENotificationsService } from "@services/ui-helpers/notifications-services/be-notifications.service";
import { Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class MaintenanceGuard implements CanActivate {
  private notificationsService = inject(BENotificationsService);
  private router = inject(Router);

  canActivate(): Observable<boolean> {
    if (!this.notificationsService.isBackendOnline) {
      this.router.navigate(["/maintenance"]);
      return of(false);
    }
    return of(true);
  }
}
